import React from "react";

export default function CubeCard({ title, icon, isHidden,className = 'card cube-card' }) {
    if (isHidden)  return <div className="card card-hidden"></div>;

    console.log(typeof icon)
    return (
        <div className={className}>
            {typeof icon === 'string' && <img className="card-image" src={icon} alt={title} />}
            {typeof icon === 'object' && <span className="card-image">{icon}</span>}
            <h3 className="card-title">{title}</h3>
        </div>
    );
}
